export const reports = {
  description: "تقارير تشغيلية ومالية مع فلاتر التاريخ وتصدير CSV.",
  downloadCsv: "تنزيل CSV",
  report: "تقرير",
  noRows: "لا توجد صفوف",
  noRowsDesc: "عدّل نطاق التاريخ أو أنشئ سجلات لعرض النتائج.",
  defs: {
    quoteConversion: "تحويل عروض الأسعار",
    jobStatus: "حالة أوامر العمل والأعمال المتأخرة",
    wip: "الأعمال قيد التنفيذ حسب مركز العمل",
    stockReorder: "المخزون ونقاط إعادة الطلب",
    openPos: "أوامر الشراء المفتوحة",
    actualVsEstimate: "الفعلي مقابل التقديري",
    invoiceAging: "تقادم الفواتير",
    cashActivity: "حركة النقدية",
  },
};
